const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { RichText } = wp.editor;
const { withSelect } = wp.data;

import { ReactComponent as FsLogo } from "../../assets/fs_logo.svg";
import fsLogoUrl from "./fs_logo.svg";

registerBlockType("fast-simon/category", {
	title: __("Category", "instantsearch-for-woocommerce"),
	icon: { src: FsLogo },
	icon: "category",
	category: "fast-simon",
	edit: props => {

		console.info(props);

		const { className } = props;

		return (
			<div className={`${className} fast-simon-block fast-simon-category`} >

				<figure className="logo">
					<img src={fsLogoUrl} alt="logo" />
				</figure>

				<p className="block-title">Fast Simon's Category Block</p>

				<p className="block-info">
					Enter the Fast Simon Dashboard to edit configurations via the admin menu
				</p>

			</div>
		);
	},

	save(props) {
		return null;
	}
});
